<template>
    <div>
        <label>Välj klass</label> 
        <dropdown
            :options="categories"
            label-key="name"
            value-key="id"
            :value="selectedCategory"
            :searchable="true"
            placeholder="Välj klass"
            @input="onCategorySelect"
        />
    </div>
</template>

<script>
import dropdown from 'vue@/components/dropdown.vue';

export default {
    name: 'CategorySelect',
    components: { dropdown },
    props: {
        categories: {
            type: Array,
            required: true
        },
        selectedCategory: {
            type: [Number, String, null],
            default: null
        }
    },
    methods: {
        onCategorySelect(categoryId) {
            this.$emit('category-selected', categoryId);
        }
    }
};
</script>